// extracted by mini-css-extract-plugin
module.exports = {"iconAndBenefit":"styles_iconAndBenefit__erdf7","icon":"styles_icon__NqeL8","benefit":"styles_benefit__QHgue"};